import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=de11445a&"
import script from "./policy.vue?vue&type=script&setup=true&lang=js&"
export * from "./policy.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports